import { useErrorReporter } from '@/composables/useErrorReporter'

export default defineNuxtPlugin(nuxtApp => {
	const { bugsnagReport } = useErrorReporter()

	const getComponentName = instance =>
		instance?.$options?.name || instance?.$options?.__name || undefined

	nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
		bugsnagReport({
			error: error instanceof Error ? error : new Error(error),
			metaData: {
				errorInfo: info,
				componentName: getComponentName(instance)
			}
		})
	}

	nuxtApp.hook('vue:error', (error, instance, info) => {
		bugsnagReport({
			error: error instanceof Error ? error : new Error(error),
			metaData: {
				errorInfo: info,
				componentName: getComponentName(instance)
			}
		})
	})
})
